import React, { useEffect, useState } from 'react';
import { useCart } from '../context/CartContext';
import './CartNotification.css';

function CartNotification() {
  const { notification, clearNotification } = useCart();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (notification) {
      setIsVisible(true);
      const timer = setTimeout(() => {
        setIsVisible(false);
        setTimeout(clearNotification, 300);
      }, 3500);
      return () => clearTimeout(timer);
    }
  }, [notification, clearNotification]);

  if (!notification) return null;

  return (
    <div className={`cart-notification ${isVisible ? 'visible' : ''}`}>
      <div className="cart-notification-content">
        <div className="cart-notification-icon">
          <span>✓</span>
        </div>
        <div className="cart-notification-text">
          <p className="cart-notification-title">Added to Cart!</p>
          <p className="cart-notification-product">{notification.product}</p>
        </div>
        <a href="/cart" className="cart-notification-link">
          Go to Cart →
        </a>
      </div>
      <div className="cart-notification-progress"></div>
    </div>
  );
}

export default CartNotification;
